import React from 'react';
import { getBillingUrl, goLogin } from "../../../../common/utils/passUtil";

export default function PassBox(props) {

  const checkJoinPlatform = (billingUrl, target, option) => {
    if (!props.loginJwt) {
      window.location.href = goLogin();
      return;
    }

    // 트위터 / 페이스북 유료결제 제한
    const targetDate = new Date('2024-08-27T14:00:00+09:00');
    const currentDate = new Date();

    if (currentDate >= targetDate && (props.platform === 'T' || props.platform === 'F')) {
      const message = props.displayLang === 'ko'
        ? '페이스북 및 트위터를 통한 결제는 불가능합니다.\n다른 로그인 방법을 사용해 결제해 주세요.'
        : 'Payment through Facebook and Twitter is not possible.\nPlease use a different login method to pay.';
      alert(message);
      return false;
    }
    window.open(billingUrl, target, option);
  };

  const renderTextWithLineBreaks = (text) => {
    return text.split('<br>').map((line, index, array) => (
      <span key={index}>
        {line}
        {index < array.length - 1 && <br />}
      </span>
    ));
  };

  return (
    <>
      {
        props.data.map((item, index) => {
          const billingUrl = getBillingUrl(props.loginJwt, 'pc', item.module_type == '1' ? props.group : 'inapp', item.product_id)
          const option = 'width=570,height=700,resizable=yes,scrollbars=yes'
          const target = 'Billing'

          return (
            <div key={`pass-box-${index}`} className={`passModule_type${item.module_type}`}>
              {item.label && (
                <span className={`moduleLabel-${item.label.type}`}>
                  {item.label.text}
                </span>
              )}
              {item.module_type === '2' && (
                <span className="moduleLabel-sale">16% 할인</span>
              )}
              <a href="#" className="passModuleLink" onClick={() => checkJoinPlatform(billingUrl, target, option)}>
                <div className="passModuleCont">
                  <strong className="passModuleTitle">{item.product_name}</strong>
                  <div class="passModuleSText">{renderTextWithLineBreaks(item.sub_description)}</div>
                  <div className="passModuleNumber">{item.price_pc}
                    {item.price_sub && item.module_type === '2' ? <span className="sText">{item.price_sub}</span> : ''}
                  </div>
                </div>
                {/* <div className="passModuleInfo_w">
                  {
                    item.support.map((support, index) => {
                      return (
                        <div key={`pass-box-support-${index}`} className="passModuleInfo_text">
                          {support.info && (
                            <>
                              <span dangerouslySetInnerHTML={{ __html: support.info }} />
                              <span dangerouslySetInnerHTML={{ __html: support.label }} />
                            </>
                          )}
                        </div>
                      )
                    })
                  }
                </div> */}
              </a>
            </div>
          )
        })
      }
    </>
  );
}
